import { ComingSoonItem } from "@/components/atoms/Items/ComingSoonItem";
import { MainTemplate } from "@/components/templates/MainTemplate";
import React from "react";

const ReviewDetailPage = () => {
  return (
    <MainTemplate>
      <ComingSoonItem />
    </MainTemplate>
  );
};

export default ReviewDetailPage;
